<template>
  <div class="lock-final-goal-name-wrapper">
    <slot />
    <span class="lock-final-goal-name-wrapper__placeholder">最終目標</span>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.lock-final-goal-name-wrapper {
  display: flex;
  align-items: center;
  background-color: $white;
  height: 48px;
  padding: 8px;
  border-radius: 4px;

  &__placeholder {
    padding-left: 8px;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>